import React from "react";
import SupportUs from './SupportUs';
import ModalOne from '../Modals/ModalOne';





function SupportUsSection(props) {


  const [OpenZelle, setOpenZelle] = React.useState(false);
  const handleOpenZelle = () => setOpenZelle(true);
  const ZellehandleClose = () => setOpenZelle(false);

  const [OpenQuickPay, setOpenQuickPay] = React.useState(false);
  const handleOpenQuickPay = () => setOpenQuickPay(true);
  const QuickPayhandleClose = () => setOpenQuickPay(false);

  const [OpenSendCheck, setOpenSendCheck] = React.useState(false);
  const handleSendCheck = () => setOpenSendCheck(true);
  const SendCheckhandleClose = () => setOpenSendCheck(false);


  const cTAEightData = [
    { icon: "https://cdn.mytakbir.com/static-assets/logos/deen360-islam-learning-management-system-logo-deenfund-donation.png.svg", link: "https://give.deenfund.com/muna-academy", target: "_blank", Iconheight:"44px", IconStatus:true, },
    // { icon: Paypal, link: "https://www.paypal.com/us/signin" },

    { icon: "https://cdn.mytakbir.com/static-assets/logos/deen360-islam-learning-management-system-logo-zelle.png.png", onClick: handleOpenZelle, IconStatus:true, },
    // { icon: Chase, onClick: handleOpenQuickPay, TitleafterLogo: "QuickPay" },
    {  lebel: "SEND CHECK BY MAIL", onClick: handleSendCheck, space:"15px", },
  ];


  return (
    <>
      <SupportUs
        cTAEightData={cTAEightData}
        backgroundColor="#4C9B40"
        backgroundColorRight="#56B149"
        color="#fff"
        btnlebelcolor="#33B651"

        Title="MANY WAYS TO SUPPORT MUNA ACADEMY"
        SubTitle="Al-Tirmidhi"
        ButtonLebel="DONATE NOW"
        minHeight="250px"

        //=== left col content ===/
        TitleLeft="SUPPORT MUNA ACADEMY"
        LeftDescription="The Prophet ﷺ said, the most beloved of deeds to Allah are those that are most consistent, even if it is small."
        bookname="(Sahih Bukhari)"
        LeftBottomText={<span>Please donate min of $1 everyday ($30/monthly) <br/> <br/>Donations are securely powered by DEENFUND</span>}


      />

      <ModalOne
        open={OpenZelle}
        handleClose={ZellehandleClose}
        width="660px"
        title="DONATE VIA ZELLE"
        titileColor="#33B651"
        padding="60px"

        body={
          <div>
            <p>ZELLE EMAIL</p>
            <a href="mailto:muna.acad@gmail.com"> muna.acad@gmail.com</a>
          </div>
        }

      />

      <ModalOne
        open={OpenQuickPay}
        handleClose={QuickPayhandleClose}
        width="660px"
        title="DONATE VIA CHASE QUICKPAY"
        titileColor="#33B651"
        padding="60px"

        body={
          <div>
            <p>EMAIL</p>
            <a href="mailto:muna.acad@gmail.com"> muna.acad@gmail.com</a>
          </div>
        }

      />

      <ModalOne
        open={OpenSendCheck}
        handleClose={SendCheckhandleClose}
        width="660px"
        title="SEND CHECK BY MAIL"
        titileColor="#33B651"
        padding="60px"

        body={
          <div>
            <p>Payable to:</p>
            <a>MUNA Academy Inc</a>
            <br/><br/>
            <p>Mail the check to - Address:</p>
            <a>MUNA Academy Inc<br />
            1033 Glenmore Ave. 4th Fl
              <br/>Brooklyn, NY 11208</a>

          </div>
        }

      />


    </>
  );
}

export default SupportUsSection;
